export const JHD_DASHBOARD_TAG_NAME = 'jhd-dashboard';
